export default "__VITE_ASSET__30c146c3__"